export default __webpack_public_path__ + "static/media/bg-copro.a594b781.jpg";